import { render, staticRenderFns } from "./MentionsLegals.vue?vue&type=template&id=e8163eda&scoped=true"
import script from "./MentionsLegals.vue?vue&type=script&lang=js"
export * from "./MentionsLegals.vue?vue&type=script&lang=js"
import style0 from "./MentionsLegals.vue?vue&type=style&index=0&id=e8163eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.aspect_rules_js/vue-loader@15.11.1_200321279/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8163eda",
  null
  
)

export default component.exports